import { render, staticRenderFns } from "./PublicQuotationPages3.vue?vue&type=template&id=3277cde7&scoped=true&"
import script from "./PublicQuotationPages3.vue?vue&type=script&lang=js&"
export * from "./PublicQuotationPages3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3277cde7",
  null
  
)

export default component.exports